import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { ADMIN_ID } from "./Constant";

const CommentSection = ({ slug }) => {
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState("");
    const [visibleCount, setVisibleCount] = useState(2);
    const navigate = useNavigate();
    const url = API_BASE_URL

    const fetchData = () => {
        fetch(`${url}/blog-comment/${slug}`)
            .then((res) => res.json())
            .then((data) => setComments(Array.isArray(data.data) ? data.data : []))
            .catch((err) => console.error("❌ Error fetching comments:", err));
    }
    useEffect(() => {
        if (!slug) return;
        fetchData();
    }, [slug]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newComment.trim()) return;

        try {
            const res = await fetch(`${url}/blog-comment`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    blog_id: slug,
                    message: newComment,
                }),
            });

            if (!res.ok) {
                console.error("❌ Server error:", await res.text());
                return;
            }

            const saved = await res.json();
            fetchData();
            // setComments([saved, ...comments]);
            setNewComment("");
            setVisibleCount((prev) => prev + 1);
        } catch (err) {
            console.error("❌ Failed to post comment:", err.message);
        }
    };

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-4 my-3">
            <h3 className="flex items-center gap-2 text-lg font-semibold text-black mb-3">
                <MessageCircle className="text-[#4e59c2]" size={18} />
                Comments ({comments.length})
            </h3>

            {/* Comment Form */}
            <form onSubmit={handleSubmit} className="mb-4">
                <textarea
                    rows="3"
                    placeholder="Write your comment..."
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-1 focus:ring-[#6274cf] focus:outline-none text-black placeholder-gray-400 text-sm"
                />
                <button
                    type="submit"
                    className="mt-2 bg-[#4e59c2] text-white px-3 py-1.5 rounded-md text-sm hover:bg-[#4449b1] transition"
                >
                    Post Comment
                </button>
            </form>

            {/* Comment List */}
            <ul className="space-y-3">
                {comments.slice(0, visibleCount).map((comment, index) => (
                    <li
                        key={index}
                        className="p-3 bg-gray-50 border border-gray-200 rounded-md"
                    >
                        <div className="flex justify-between items-center mb-1">
                            <strong className="text-black text-sm">
                                {comment.author || "Anonymous"}
                            </strong>
                            <span className="text-xs text-gray-500">
                                {new Date(comment.createdAt).toLocaleString()}
                            </span>
                        </div>
                        <p className="text-gray-800 text-sm">{comment.message}</p>
                    </li>
                ))}
            </ul>

            {/* View All */}
            {comments.length > visibleCount && (
                <div className="mt-3 text-center">
                    <button
                        onClick={() => navigate(`/blogs/${slug}/comments`)}
                        className="text-[#4e59c2] hover:text-[#3e4096] text-sm font-medium"
                    >
                        View All Comments
                    </button>
                </div>
            )}
        </div>
    );
};

export default CommentSection;
